export class LdapConnection2 {
}
